import React from 'react';
import ModalAddMailing from '../ModalAddMailing';
import ModalComments from '../ModalComments';
import { format } from 'date-fns';
import { makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { setDeleteUsers } from '../../../../store/mailing/thunk/setDeleteUsers';
import TableCasino from '../../../../../@casino/ui/table';
import { setGetMailingUsers } from '../../../../store/mailing/thunk/setGetMailingUsers';

const useStyles = makeStyles(() => ({
    btn: {
        padding: '3px 14px',
        borderRadius: 4,
        background: '#ffc324',
        color: '#141b33',
        cursor: 'pointer',
        border: 'none',
        fontSize: 16
    },
}))

const TabGeneral = ({ mailing, id }) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const [selected, setSelected] = React.useState(undefined);
    const [isOpenModalAddMailing, setIsOpenModalAddMailing] = React.useState(false)
    const [isOpenModalComments, setIsOpenModalComments] = React.useState(false);

    const users = useSelector((state) => state.mailing.users);

    const columns = [
        { id: 'id', label: 'id' },
        { id: 'login', label: 'Логин' },
        { id: 'gift_type', label: 'Тип подарка' },
        { id: 'gift_value', label: 'Количество/Сумма' },
        { id: 'is_available', label: 'Выдано' }
    ];

    columns.push({ id: 'settings', label: 'Дополнения' })


    const handleChangeModeAddMailing = () => {
        setIsOpenModalAddMailing(value => !value);
        setSelected(undefined)
    }

    const handleChangeModeComments = () => {
        setIsOpenModalComments(value => !value);
        setSelected(undefined)
    }


    const getRows = (list) => {
        return list.map((item) => {
            return {
                id: item.id,
                login: item.login,
                gift_type: item.gift_type,
                gift_value: item.gift_value,
                is_available: item.is_available ? 'Выдано' : 'Не выдано',
                settings: mailing?.is_start === false ? (
                    <div style={{ display: 'flex', columnGap: 10 }}>
                        <button
                            type="button"
                            className={classes.btn}
                            onClick={() => {
                                setIsOpenModalAddMailing(value => !value);
                                setSelected(item)
                            }}
                        >
                            Изменить
                        </button>
                        <button
                            type="button"
                            className={classes.btn}
                            onClick={() => {
                                dispatch(setDeleteUsers({ id: item.id, mailing_id: id }));
                            }}
                        >
                            Удалить
                        </button>
                    </div>
                ) : !item?.comments_from_operator ? (
                    <div style={{ display: 'flex', columnGap: 10 }}>
                        <button
                            type="button"
                            className={classes.btn}
                            onClick={() => {
                                setIsOpenModalComments(value => !value);
                                setSelected(item)
                            }}
                        >
                            Оставить комментарий
                        </button>
                    </div>
                ) : item?.comments_from_operator?.length > 50 ? item?.comments_from_operator.slice(0, 50) + '...' : item?.comments_from_operator
            }
        })
    }

    const rows = React.useMemo(() => getRows(users.data), [users.data]);


    return (
        <div>
            <div style={{
                padding: 10,
                background: '#1b2039',
                margin: '12px 0',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: 8
            }}>
                <div style={{ display: 'flex', columnGap: 10, color: '#fff', fontSize: 16 }}>
                    <span>Дата рассылки</span> &mdash;
                    <span>{format(new Date(Number(mailing?.mailing_date_at || 0)), 'dd.mm.yyyy')}</span>
                </div>
                <div style={{ color: '#fff', fontSize: 16 }}>
                    <span>{mailing?.label}</span>
                </div>
                <div style={{ color: '#fff', fontSize: 16 }}>
                    <span>{mailing?.description}</span>
                </div>
            </div>

            <div style={{
                padding: 10,
                background: '#1b2039',
                margin: '12px 0',
                display: 'flex',
                alignItems: 'center',
                borderRadius: 8
            }}>
                <TableCasino
                    pagination
                    allPage={users.pagination.totalPage}
                    width={"100%"}
                    perPage={25}
                    columns={columns}
                    rows={rows}
                    changePage={(v) => {
                        dispatch(setGetMailingUsers({
                            id,
                            page: Number(v.page) + 1,
                            pageSize: v.rowsPerPage
                        }))
                    }}
                    changeRowsPerPage={(v) => {
                        dispatch(setGetMailingUsers({
                            id,
                            page: 1,
                            pageSize: v.rowsPerPage
                        }))
                    }}
                />
            </div>
            {
                isOpenModalAddMailing && (
                    <ModalAddMailing handleChangeModeAddMailing={handleChangeModeAddMailing} selected={selected} />
                )
            }
            {
                isOpenModalComments && (
                    <ModalComments handleChangeModeComments={handleChangeModeComments} selected={selected} />
                )
            }
        </div>
    )
}

export default TabGeneral;